import styled from '@emotion/styled';
import vars from '@variables';
import { PAtom } from '@atoms/text-atoms/text-atoms';

export const ImageBlockContainer = styled.div`
  margin: 0;
  text-align: left;
  ${vars.fontSize8}
  height: 100%;

  ${PAtom} {
    max-width: 80%;
    margin: 0;
    ${vars.fontSize1}
    padding-top: 1rem;
  }

  a {
    display: block;
    text-decoration: none;
    height: 100%;
    &:hover {
      opacity: 0.8;
    }
  }

  img {
    height: 100%;
    width: auto;
    object-fit: contain;
    display: block;
  }

  .gatsby-image-pos > div {
    max-width: inherit !important;
    height: 100% !important;
  }

  .gatsby-image-wrapper,
  .gatsby-image-wrapper picture,
  .gatsby-image-wrapper img {
    height: 100% !important;
    width: auto !important;
    object-fit: contain !important;
    display: block;
  }
`;
